module.exports = __webpack_public_path__ + "static/media/test_report.01a5965b.png";